import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "療程安全嗎？有沒有副作用？",
    a: "ISHB 採用非手術、基因療法的修復方式，產品多為海洋生物製劑，強調安全性，面向孕婦和幼兒也可使用。所有療程均由專業認證導師操作，治療前會先進行詳細評估，確保適合你的肌膚狀況。",
  },
  {
    q: "治療過程會痛嗎？",
    a: "大部分療程以非侵入方式進行，過程舒適，只有輕微的溫熱或緊緻感。針對個別較敏感的肌膚，我們會調整治療強度，讓你在最放鬆的狀態下完成修復。",
  },
  {
    q: "如何預約諮詢？",
    a: "你可以直接致電或透過 WhatsApp 聯絡我們（+852 6943 8757），我們的團隊會為你安排免費的專業諮詢，了解你的肌膚狀況並建議最適合的療程。",
  },
  {
    q: "恢復期需要多久？",
    a: "由於採用非手術修復，大部分療程幾乎沒有恢復期，治療後即可正常生活。少數療程可能出現短暫的輕微泛紅，一般數小時至一兩天內便會消退。",
  },
  {
    q: "療程適合哪些人？",
    a: "療程適合關注皮膚健康、疤痕、妊娠紋、色素沉澱、肌膚老化等問題的人士。無論年齡或膚質，治療前都會進行評估，確保療程安全有效。",
  },
  {
    q: "需要做多少次治療才見效？",
    a: "效果因人而異，視乎肌膚問題的嚴重程度而定。一般輕微問題數次即可見效，較深層的問題則需要按療程規劃進行。諮詢時我們會提供具體的建議與預期效果。",
  },
  {
    q: "治療後有什麼注意事項？",
    a: "治療後需注意保濕與防曬，避免使用刺激性的護膚產品。我們的導師會提供詳細的居家護理指引，並跟進你的復原進度。",
  },
  {
    q: "可以同時進行多項療程嗎？",
    a: "可以。ISHB 提供整合性的修復方案，可針對不同肌膚問題制定個人化的療程組合。治療前諮詢會為你評估最合適的搭配，確保效果最佳且安全。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="min-h-screen bg-white text-brand-900">
      <Navbar />

      <section className="pt-32 md:pt-40 pb-16 md:pb-20 bg-brand-50/60">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="inline-block px-6 py-2 rounded-md bg-brand-600 text-white text-lg tracking-wider">常見問答</div>
          <h1 className="mt-6 font-serif text-3xl md:text-5xl text-brand-800">您想了解的，都在這裡</h1>
          <p className="mt-4 text-brand-700/70 max-w-2xl text-sm md:text-base">
            關於療程、預約、恢復期等常見問題的解答。如仍有疑問，歡迎隨時聯絡我們的專業團隊。
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 space-y-4">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-lg border transition ${
                  isOpen ? "border-brand-300 bg-brand-50/50" : "border-brand-100 bg-white"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-brand-800 text-sm md:text-base">{f.q}</span>
                  <span
                    className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition ${
                      isOpen ? "bg-brand-600 text-white" : "bg-brand-50 text-brand-700"
                    }`}
                  >
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line text-lg`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm text-brand-700/75 leading-relaxed">{f.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
}